module.exports = __webpack_public_path__ + "nc_static/media/dd_diagnostic_info.82b6c4c4.svg";